import { useEffect, useRef } from "react";

/**
 * Run `callback` after `delay` ms when `deps` change.
 * Skips the first run so mount-time list APIs don't double-fire.
 */
export function useDebouncedEffect(callback, deps, delay = 400) {
  const callbackRef = useRef(callback);
  const isFirstRun = useRef(true);

  callbackRef.current = callback;

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return undefined;
    }

    const timer = setTimeout(() => {
      callbackRef.current();
    }, delay);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
